import {Button} from '@wandb/weave/components/Button';
import React, {useCallback, useState} from 'react';
import {toast} from 'react-toastify';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Header, Modal} from 'semantic-ui-react';

import {useDeleteTriggerMutation} from '../../../generated/graphql';
import {InstrumentedLoader as Loader} from '../../utility/InstrumentedLoader';

type DeleteTriggerModalProps = {
  open: boolean;
  onClose: () => void;
  triggerID: string;
  triggerName: string;
  afterDelete: () => void;
};

export const DeleteTriggerModal = ({
  open,
  onClose,
  triggerID,
  triggerName,
  afterDelete,
}: DeleteTriggerModalProps) => {
  const [isDeleting, setDeleting] = useState(false);
  const [deleteTriggerMutation] = useDeleteTriggerMutation();

  const onDeleteClick = useCallback(async () => {
    setDeleting(true);

    try {
      await deleteTriggerMutation({
        variables: {
          triggerID: triggerID ?? '',
        },
      });
      afterDelete();
    } catch (error) {
      console.error(error);
      toast('Something went wrong while trying to delete this artifact.');
    }
    setDeleting(false);
    onClose();
  }, [triggerID, afterDelete, deleteTriggerMutation, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      {isDeleting ? (
        <Loader active name="delete-trigger-modal" />
      ) : (
        <>
          <Header>
            <p>Delete '{triggerName}'?</p>
          </Header>
          <Modal.Content>
            This cannot be undone. Runs and artifacts already created by this
            trigger will not be affected.
          </Modal.Content>
          <Modal.Actions>
            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Button
                variant="secondary"
                size="large"
                onClick={() => {
                  onClose();
                }}
                style={{marginRight: '8px'}}>
                Cancel
              </Button>
              <Button
                icon="delete"
                variant="destructive"
                size="large"
                data-cy="triggers-delete-confirm"
                onClick={onDeleteClick}>
                Delete
              </Button>
            </div>
          </Modal.Actions>
        </>
      )}
    </Modal>
  );
};
